import React from "react";
import Tag from "./logotager.png";
import { useNavigate } from "react-router-dom";

const HomePage = () => {
  const navigate = useNavigate();

  // Two main buttons
  const buttons = [
    { name: "P1", url: "/part1" },
    { name: "P2", url: "/part2" },
  ];

  const openInNewTab = (url) => {
    //const baseUrl = "http://localhost:3000"; // Adjust if needed
    const baseUrl = "https://tagprotect.in";
    window.open(`${baseUrl}${url}`, "_blank", "noopener,noreferrer");
  };

  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    localStorage.setItem("logout-event", Date.now());
    window.location.href = "/";
  };

  return (
    <div style={styles.container}>
      <div style={styles.imageSidebar}>
        <img src={Tag} alt="Sidebar" style={styles.image} />
      </div>

      <div style={styles.centerContent}>
        {buttons.map((item) => (
          <button
            key={item.name}
            style={styles.centerButton}
            onClick={() => openInNewTab(item.url)}>
            {item.name}
          </button>
        ))}
      </div>

      <button className="logout2-btn" onClick={handleLogout}>
        Logout
      </button>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    height: "100vh",
    position: "fixed",
    marginTop: "5%",
  },
  imageSidebar: {
    width: "45%",
    backgroundColor: "#FFF",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "-17%",
  },
  image: {
    width: "45%",
    height: "auto",
    objectFit: "contain",
  },
  centerContent: {
    flex: 1,
    marginTop: "-10%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
  },
  centerButton: {
    minWidth: "315px",
    height: "50px",
    padding: "0 15px",
    color: "#fff",
    backgroundColor: "#007BFF",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    marginBottom: "10px",
    fontSize: "18px",
    fontWeight: "bold",
    letterSpacing: "0.5px",
    fontFamily: "sans-serif",
    textAlign: "center",
    lineHeight: "50px",
    transition: "background-color 0.3s",
    whiteSpace: "nowrap",
  },
};

export default HomePage;
